import { useEffect } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { TextStyle, FontFamily, FontSize, Color } from "@tiptap/extension-text-style";
import TextAlign from "@tiptap/extension-text-align";
import { TableKit } from "@tiptap/extension-table";
import Image from "@tiptap/extension-image";
import EditorToolbar from "@/components/letters/EditorToolbar";
import { BlockStyle, PageBreak } from "@/components/letters/extensions";

export const EXTENSIONS = [
  StarterKit.configure({ link: { openOnClick: false, autolink: true } }),
  TextStyle, FontFamily, FontSize, Color, BlockStyle, PageBreak,
  TextAlign.configure({ types: ["heading", "paragraph"] }),
  TableKit.configure({ table: { resizable: false } }),
  Image.configure({ allowBase64: true }),
];

// Éditeur riche façon traitement de texte (page blanche A4)
export default function RichEditor({ value, onChange, onReady, onAiSelection, editable = true }) {
  const editor = useEditor({
    extensions: EXTENSIONS,
    content: value || "",
    editable,
    shouldRerenderOnTransaction: true,
    editorProps: { attributes: { class: "letter-content focus:outline-none min-h-[520px]", "data-testid": "letter-editor" } },
    onUpdate: ({ editor: e }) => onChange(e.getHTML()),
  });
  useEffect(() => { if (editor && onReady) onReady(editor); }, [editor]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="rounded-xl border bg-slate-200/60 overflow-hidden" data-testid="rich-editor">
      {editable && <EditorToolbar editor={editor} onAiSelection={onAiSelection} />}
      <div className="p-2 sm:p-6 overflow-x-auto">
        <div className="mx-auto bg-white shadow-md w-full max-w-[794px] px-5 sm:px-[68px] py-10" style={{ fontFamily: "Times New Roman", fontSize: "12pt" }}>
          <EditorContent editor={editor} />
        </div>
      </div>
    </div>
  );
}
